// Packages
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Other
import './styles.css';

const BTDTextareaField = ({ description, error, label, onChange, required, rows, style, tabIndex, value, width }) => {

    const [active, setActive] = useState(false);

    useEffect(() => {

        if( value != null && value !== '' ) {

            setActive(true);
        }
        else {

            setActive(false)
        }
    }, [value])


    return(
        <>
        {description &&
            <p className='BTDTextareaField__description detail' dangerouslySetInnerHTML={{__html: description}}></p>
        }
        <div className={`BTDTextareaField ${width}`} style={style}>
            <label className={`BTDTextareaField__label ${active ? 'active' : ''}`}>{label ?? ''}
                {required &&
                    <span className='red'>{<>&nbsp;</>}*</span>
                }
            </label>
            <textarea 
                className={`BTDTextareaField__input ${error ?? ''}`} 
                onChange={(e) => {onChange(e.target.value)}} 
                required={required} 
                rows={rows}
                tabIndex={tabIndex ?? 0}
                value={value}
            />
            {error &&
                <p className='BTDTextareaField__error'>{error}</p>
            }
        </div>
        </>
    )
}

BTDTextareaField.propTypes = {
    description: PropTypes.string,
    error: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    rows: PropTypes.number,
    style: PropTypes.object,
    tabIndex: PropTypes.number,
    value: PropTypes.string,
    width: PropTypes.string
}

BTDTextareaField.defaultProps = {
    description: null,
    error: null,
    label: '',
    onChange: () => {alert('onChange is not set!')},
    required: false,
    rows: 6,
    style: {},
    tabIndex : 0,
    value: null,
    width: 'large'
}

export default BTDTextareaField;                                         